import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { InlineTooltipComponent } from '@frontend/sports/tooltip-feature';

@Component({
    selector: 'ms-game-notes',
    templateUrl: './game-notes.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [InlineTooltipComponent],
})
export class GameNotesComponent {
    @Input() gameNotes?: string;
}
